module.exports = __webpack_public_path__ + "img/太庙.4c6c19e5.jpg";